import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Result, Button } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import './PageNotFound.css';
import { useNavigate } from 'react-router-dom';

const PageNotFound = ({ history }) => {
  const navigate = useNavigate();

  return (
    <div className="not-found-page">
      {/* SEO Head Tags for 404 */}
      <Helmet>
        <html lang="en" />
        <title>Page Not Found | GentleGourmet</title>
        <meta
          name="description"
          content="Oops! The page you're looking for doesn't exist. Return to GentleGourmet to find digestive-friendly recipes for GERD, IBS, and gastritis."
        />
        <meta name="robots" content="noindex, follow" />
        <meta property="og:title" content="Page Not Found | GentleGourmet" />
        <meta
          property="og:description"
          content="The page you're looking for doesn't exist. Discover digestive-friendly recipes at GentleGourmet."
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="GentleGourmet" />
      </Helmet>

      <Result
        status="404"
        title="404"
        subTitle="Ohhh my stomach! The page you're looking for doesn't exist."
        extra={
          <Button
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded disabled:opacity-50"
            type="primary"
            onClick={() => navigate("/")}
          >
            <HomeOutlined /> Go Home
          </Button>
        }
      />
    </div>
  );
};

export default PageNotFound;